import dayjs from 'dayjs';
import { DATEFORMAT_LOCAL_STATE } from '@ps20-frontend/utils';
import { Selbstbeteiligung, Zahlungsart, Zahlweise } from '@ps20/bff-models';
import { IAppState } from './appState';
import { VersicherungssummeEnum } from './model/vertragsoptionen.model';

export const INITIAL_STATE: IAppState = {
  version: 17,
  antragsnummer: null,
  vorbelegungen: {
    adresseImmobilieVorbelegt: false,
    versicherungsnehmerVorbelegt: false,
    activateElementar: false,
  },
  versicherungsnehmer: {
    geburtsdatum: '',
    familienstand: null,
    isAssekuranztarif: false,
    juristisch: false,
    adresse: {
      plz: '',
      ort: '',
      strasse: '',
      hausnummer: '',
    },
  },
  risikoort: {
    plz: '',
    ort: '',
    strasse: '',
    hausnummer: '',
    land: {
      text: '',
      wert: '',
    },
  },
  adressvorschlag: {
    orte: [],
    strassen: [],
    lastError: null,
  },
  versObjekt: {
    staendigBewohnt: true,
    wohnflaeche: null,
    hausart: null,
    gebaeudeStaendigBewohnt: true,
    gebaeudeInnerhalbWohngebiet: true,
    stockwerk: null,
  },
  versicherungssummen: [],
  vorschaeden: {
    vorhanden: null,
    fels: 0,
    fahrrad: 0,
    elementar: 0,
    elementarVisibleInErsatzgeschaeft: false,
  },
  vertragsoptionen: {
    selbstbeteiligung: Selbstbeteiligung.SELBSTBETEILIGUNG_0300,
    zahlungsweise: Zahlweise.MONATLICH,
    vertragslaufzeit: 3,
    ausgewaehltevertragslaufzeit: 3,
    versicherungssummeArt: VersicherungssummeEnum.EMPFOHLEN_VERSSUMME,
    versicherungssumme: null,
    zahlungsart: Zahlungsart.LASTSCHRIFT,
    beginnDatum: dayjs().add(1, 'd').format(DATEFORMAT_LOCAL_STATE),
    aenderungdatum: dayjs().add(1, 'd').format(DATEFORMAT_LOCAL_STATE),
    vorversicherungVorhanden: null,
    isWeitererVertrag: false,
  },
  produkt: null,
  taasInfo: {
    hashedTaasRequest: '',
    hashedRiskData: '',
    rbdNachlass: 0,
    tbNachlass: 0,
    aktionsnachlass: 0,
    savedRbdNachlass: 0,
    savedTbNachlass: 0,
    savedAktionsnachlass: 0,
  },
  gisDaten: null,
  plzFaktoren: null,
  jahresbeitrag: 0,
  gesamtbeitrag: 0,
  gesamtbeitragMitRabatt: 0,
  savedGesamtbeitragMitRabatt: 0,
  savedJahresbeitragMitRabatt: 0,
  wertsachensummen: null,
  selectedWertsachensumme: null,
  unterversicherungsverzicht: false,
  versicherungssummeFahrrad: [],
  entschaedigungsgrenzeRad: [],
  transientState: {
    zurueckZumShopModalOpen: false,
    tarifierungIsInProgress: false,
    adressvorschlagIsInProgress: null,
    featureToggles: {},
    regexps: {},
    fehlerCodeTaas: '',
    priceGuarantee: false,
    role: null,
    vorvertragVorschaeden: null,
    vhvVorhandenError: null,
    mapViewModal: {
      isOpen: false,
      isAdresseTarifierbar: true,
      origin: null,
    },
    relevantVorbelegungdaten: null,
    formValidationTriggered: false,
    kooperationen: null,
    showZumAngebotLoadingSpinner: false,
  },
  elementarSelbstbehalt: {
    id: null,
    description: '',
  },
  extremwetterschutzSelbstbeteiligung: null,
  tragerisiko: null,
  rabattstufe: 0,
  hoechsteEinzelwerte: {}
};
